// extracted by mini-css-extract-plugin
module.exports = {"GeneralInformation":"generalInformation_GeneralInformation__2OZUX","Label":"generalInformation_Label__kUXnW"};